module.exports = __webpack_public_path__ + "static/media/DM.afe423a9.jpg";